<template>
  <v-dialog v-model="isFlashCodeDialogOpen" width="500">
    <v-card>
      <v-flex pr-4 pl-4 pt-2 pb-2>
        <img :src="getQrcodeUrl" alt="flashCode" />
      </v-flex>
      <v-card-actions>
        <v-flex layout row pl-2 pr-2>
          <v-btn
            v-if="cancelIsPossible"
            outline
            flat
            color="primary"
            class="text-none"
            @click="closeQrcodeDialog"
          >
            {{
              $t('managePath.textDialogInformations.default.cancelButtonText')
            }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :color="confirmButtonColor"
            class="text-none white--text"
            @click="downloadQrcode"
          >
            <a @click.prevent="downloadQrcode" />
            {{
              $t('managePath.textDialogInformations.access.qrCodeDownloadText')
            }}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//import ImageInput from './ImageInput';
import axios from 'axios';

export default {
  name: 'QrCodeDialog',
  props: {
    isFlashCodeDialogOpen: {
      type: Boolean,
      default: false,
    },
    qrCodeValue: {
      type: String,
      default: null,
    },
    qrCodeName: {
      type: String,
      default: null,
    },
    cancelIsPossible: {
      type: Boolean,
      default: true,
    },
    confirmButtonColor: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      defaultText: {
        confirm: this.$t('managePath.textDialogInformations.default.confirm'),
        cancel: this.$t('managePath.textDialogInformations.default.cancel'),
      },
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    qrCodeFileName() {
      return `explorama-qrcode-${this.qrCodeName}`;
    },
    getQrcodeUrl() {
      if (this.qrCodeValue) {
        return this.qrCodeValue.length
          ? `https://api.qrserver.com/v1/create-qr-code/?size=450x450&data=${this.qrCodeValue}`
          : '';
      }
      return;
    },
  },
  methods: {
    downloadQrcode() {
      axios
        .get(this.getQrcodeUrl, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'image/png' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.qrCodeFileName;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
      this.closeQrcodeDialog();
    },
    closeQrcodeDialog() {
      this.$emit('close-dialog');
    },
  },
};
</script>
